'use client';
import { createStyles, rem } from '@s7/styles';
import { isString } from '@s7/utils';
import { OPACITY_PROPERTY } from './Overlay.contract.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const cssVar = (name)=>`var(${name})`;
const getColorStyles = (theme, color)=>{
    const { themeColor, primaryShade, rgba, gradient } = theme.fn;
    if (isString(color)) {
        return {
            backgroundColor: rgba(primaryShade(themeColor(color)), cssVar(OPACITY_PROPERTY))
        };
    }
    return {
        backgroundImage: gradient(_extends({}, color, {
            opacity: cssVar(OPACITY_PROPERTY)
        }))
    };
};
var useStyles = createStyles((theme, { color, blur, radius, fixed, zIndex })=>{
    return {
        root: _extends({}, theme.fn.cover(0), getColorStyles(theme, color), blur && {
            backdropFilter: `blur(${rem(blur)})`
        }, radius && {
            borderRadius: theme.fn.borderRadius(radius)
        }, {
            zIndex,
            '&[data-center]': {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            },
            position: fixed ? 'fixed' : 'absolute'
        })
    };
});

export { useStyles as default, getColorStyles };
//# sourceMappingURL=Overlay.styles.js.map
